/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Summary_Smpte_LabelInputs */

const en_summary_smpte_label = /** @type {(inputs: Summary_Smpte_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SMPTE`)
};

const fr_summary_smpte_label = /** @type {(inputs: Summary_Smpte_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SMPTE`)
};

const de_summary_smpte_label = /** @type {(inputs: Summary_Smpte_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SMPTE`)
};

const it_summary_smpte_label = /** @type {(inputs: Summary_Smpte_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SMPTE`)
};

const ru_summary_smpte_label = /** @type {(inputs: Summary_Smpte_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`СМПТЕ`)
};

const es_summary_smpte_label = /** @type {(inputs: Summary_Smpte_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SMPTE`)
};

const zh_cn2_summary_smpte_label = /** @type {(inputs: Summary_Smpte_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SMPTE`)
};

const ja_summary_smpte_label = /** @type {(inputs: Summary_Smpte_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SMPTE`)
};

const hi_summary_smpte_label = /** @type {(inputs: Summary_Smpte_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SMPTE`)
};

const pt_pt2_summary_smpte_label = /** @type {(inputs: Summary_Smpte_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SMPTE`)
};

/**
* | output |
* | --- |
* | "SMPTE" |
*
* @param {Summary_Smpte_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const summary_smpte_label = /** @type {((inputs?: Summary_Smpte_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Summary_Smpte_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_summary_smpte_label(inputs)
	if (locale === "de") return de_summary_smpte_label(inputs)
	if (locale === "it") return it_summary_smpte_label(inputs)
	if (locale === "ru") return ru_summary_smpte_label(inputs)
	if (locale === "es") return es_summary_smpte_label(inputs)
	if (locale === "zh-CN") return zh_cn2_summary_smpte_label(inputs)
	if (locale === "ja") return ja_summary_smpte_label(inputs)
	if (locale === "hi") return hi_summary_smpte_label(inputs)
	if (locale === "pt-PT") return pt_pt2_summary_smpte_label(inputs)
	return en_summary_smpte_label(inputs)
});